export const AttendanceReportsKey = 'attendance-reports';
export const SavedReportsKey = 'get-saved-reports';
export const GetReportsKey = 'get-reports';
export const SavedReportsAccessKey = 'saved-reports-access';
export const defaultReportsKey = 'default-reports';
export const GetAttachmentTypesKey = 'get-attachments-type';
export const ScheduleReportKey = 'schedule-report';
